// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ContractVerifyVatResponse

export type ContractVerifyVatApiResponse = {
	valid: boolean;
	name: string | null;
};

export type ContractVerifyVat = {
	valid: boolean;
	name: string | null;
};

export function hydrateContractVerifyVat(data: ContractVerifyVatApiResponse): ContractVerifyVat {
	return { ...data };
}